import { Badge } from "@/components/ui/badge";
import { statusLabel } from "@/lib/format";

export default function StatusBadge({ status, testId }) {
  const cls = `status-pill status-${status}`;
  return <span className={cls} data-testid={testId || `status-${status}`}>{statusLabel[status] || status}</span>;
}
